import { createRouter, createWebHistory } from "vue-router";
import Signin from "../views/Signin.vue";
import EditCustomer from "../views/EditCustomer.vue";
import EditBlock from "../views/EditBlock.vue";
import Block from "../views/Block.vue";
import Baja from "../views/Baja.vue";
import Blockexpenses from "../views/BlockExpenses.vue";
import BlockAccount from "../views/BlockAccount.vue";
import Customer from "../views/Customer.vue";
import Dashboard from "../views/Dashboard.vue";
import SawitBuah from "../views/SawitBuah.vue";
import SewaPajak from "../views/SewaPajak.vue";
import LorryServices from "../views/LorryServices.vue";
import LorryCostKM from "../views/LorryCostKM.vue";
import Vehicle from "../views/Vehicle.vue";
import Sewa from "../views/Sewa.vue";
import NotFound404 from "../views/NotFound404.vue";
import Product from "../views/Product.vue";
import Order from "../views/Order.vue";
import DeliveryList from "../views/DeliveryList.vue";
import OrderList from "../views/OrderList.vue";
import EditOrder from "../views/EditOrder.vue";
import BlockKerja from "../views/BlockKerja.vue";
import EditVehicle from "../views/EditVehicle.vue";
import EditSawitBuah from "../views/EditSawitBuah.vue";
import StockProfile from "../views/StockProfile.vue";
import Stock from "../views/Stock.vue";
import Gallery from "../views/Gallery.vue";
import Batch from "../views/Batch.vue";
import VehicleReports from "../views/Reports/VehicleReports.vue";
import EditBatch from "../views/EditBatch.vue";
import BatchStock from "../views/BatchStock.vue";
import Employee from "../views/Employee.vue";
import Salary from "../views/Salary.vue";
import Tender from "../views/Tender.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard-default",
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
  },
  // {
  //   path: "/users",
  //   name: "Users",
  //   component: Users,
  // },
  {
    path: "/customer",
    name: "Customer",
    component: Customer,
  },
  {
      path: "/editCustomer/:id",
      name: "EditCustomer",
      component: EditCustomer,
  },
  {
      path: "/editBlock/:id",
      name: "EditBlock",
      component: EditBlock,
  },
  {
    path: "/block",
    name: "Block",
    component: Block,
  },
  {
    path: "/sawitbuah",
    name: "SawitBuah",
    component: SawitBuah,
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/sewapajak",
    name: "SewaPajak",
    component: SewaPajak,
  },
  {
    path: "/baja",
    name: "Baja",
    component: Baja,
  },
  {
    path: "/lorryservices",
    name: "LorryServices",
    component: LorryServices,
  },
  {
    path: "/lorrycostkm",
    name: "LorryCostKM",
    component: LorryCostKM,
  },
  {
    path: "/vehicle",
    name: "Vehicle",
    component: Vehicle,
  },
  {
    path: "/sewa",
    name: "Sewa",
    component: Sewa,
  },
  {
    path: "/blockexpenses",
    name: "Blockexpenses",
    component: Blockexpenses,
  },
  {
    path: "/blockaccount",
    name: "BlockAccount",
    component: BlockAccount,
  },
  {
    path: "/blockkerja",
    name: "Block Kerja",
    component: BlockKerja,
  },
  {
    path: "/product",
    name: "Product",
    component: Product,
  },
  {
    path: "/order",
    name: "Order",
    component: Order,
  },
  {
    path: "/deliverylist",
    name: "DeliveryList",
    component: DeliveryList,
  },
  {
    path: "/orderlist",
    name: "OrderList",
    component: OrderList,
  },
  {
      path: "/editOrder/:ordersno",
      name: "EditOrder",
      component: EditOrder,
  },
  {
      path: "/editVehicle/:id",
      name: "EditVehicle",
      component: EditVehicle,
  },
  {
      path: "/stock/:status?/:id?",
      name: "Stock",
      component: Stock,
  },
  {
      path: "/editSawitBuah/:id",
      name: "EditSawitBuah",
      component: EditSawitBuah,
  },
  {
      path: "/stockProfile",
      name: "Stock Profile",
      component: StockProfile,
  },
  {
      path: "/gallery",
      name: "Gallery",
      component: Gallery,
  },
  {
      path: "/vehiclereports",
      name: "VehicleReports",
      component: VehicleReports,
  },
  {
      path: "/batch",
      name: "Batch",
      component: Batch,
  },
  {
      path: "/editBatch/:id",
      name: "EditBatch",
      component: EditBatch,
  },
  {
      path: "/batchstock/:id?",
      name: "BatchStock",
      component: BatchStock,
  },
  {
    path: "/employee",
    name: "Employee",
    component: Employee,
  },
  {
    path: "/salary",
    name: "Salary",
    component: Salary,
  },
  {
    path: "/tender",
    name: "Tender",
    component: Tender,
  },
  {
    path:"/:catchAll(.*)",
    component: NotFound404,
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
  scrollBehavior() {     
    return { top: 0, left: 0 } 
  },
});

// const loginUser = () => {
//   // var mythis = this;
  
//   axios.get('user/user')
//       .then(res => {
//         return res.data;
//       }).catch(function (error){
//           if(error.message == 'Unauthenticated.'){
//             alert('User Unauthenticated.Please login! ');
//           }else{
//               console.log('Error',error.message);
//           }
//       });
// };

router.beforeEach((to, from, next) => {
  // let isAuthenticated = false;
  // if ( ){
  //   isAuthenticated = true;
  // }
  // console.log(localStorage.getItem('token').length);
  // if (localStorage.getItem('token'))
  if ((to.name !== 'Signin' ) && !localStorage.getItem('token')) next({ name: 'Signin' })
  else if ((to.name == 'Signin' ) && localStorage.getItem('token')) next({ name: 'Dashboard'})
  else next()
});

export default router;
